import { useContext } from 'react'
import { ErrorHandlerContext } from '@/contexts'

export const useErrorHandlerContext = () => {
  const context = useContext(ErrorHandlerContext)

  if (!context) throw new Error('useErrorHandler hook have to be wrapped by ErrorHandlerContextProvider')
  
  return context
}


/* import { useState } from "react"
import { useOpeningElementsControllerContext } from "./useOpeningElementsControllerContext"

const defaultState = {
  authenticationWarn: false,
}

export const useErrorHandler = () => {
  const { errorModalOpen } = useOpeningElementsControllerContext()
  const [state, setState] = useState(defaultState)
  
  const errorHandle = (error: any) => {
    console.error('Network or server error:', error);
    // Manejar errores de red o del servidor
    if (error.networkError) {
      console.error('Network error:', error.networkError);
      errorModalOpen()
    }
    if (error.graphQLErrors) {
      error.graphQLErrors.forEach((graphQLError: any) => {
        console.error('GraphQL error:', graphQLError.message);
        if (graphQLError.extensions?.code === 'UNAUTHENTICATED') {
          console.warn('Usuario no autenticado');
          setState((prev) => ({
            ...prev,
            authenticationWarn: true
          }))
        }
      });
    }
  }

  const clearErrorState = () => setState({
    authenticationWarn: false
  })

  return {
    errorHandle,
    clearErrorState,
    state
  }
} */